import { render } from "./InternetPointDetailsModal.vue?vue&type=template&id=213c04e9&scoped=true"
import script from "./InternetPointDetailsModal.vue?vue&type=script&lang=js"
export * from "./InternetPointDetailsModal.vue?vue&type=script&lang=js"

import "./InternetPointDetailsModal.vue?vue&type=style&index=0&id=213c04e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213c04e9"]])

export default __exports__